
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
.slh-navigation {
  border-bottom: 1px solid var(--slh-color-neutral-shade-20, #EBEEF4);
  background: var(--slh-color-neutral-shade-00, #FFFFFF);
  height: 56px;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  /*
    Introduced in Internet Explorer 10.
    See http://ie.microsoft.com/testdrive/HTML5/msUserSelect/
  */
  -ms-user-select: none;
  user-select: none;
}
.slh-navigation ::slotted(slh-navigation-item) {
  margin-left: 64px;
  flex-shrink: 0;
}
.slh-navigation ::slotted(slh-navigation-item:first-child) {
  margin-left: 0;
}
.slh-navigation slot {
  display: flex;
}
.slh-navigation .active-navigation-item {
  display: none;
  padding: 24px;
  color: var(--slh-color-neutral, #39455D);
  font-family: var(--slh-default-font-family, "Open Sans");
  font-style: normal;
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  font-size: var(--slh-base-m-font-size, 16px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  border-bottom: 1px solid var(--slh-color-neutral-shade-20, #EBEEF4);
}
.slh-navigation slh-icon {
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
}
.slh-navigation .items-container {
  display: block;
  margin: 0 auto;
  height: 56px;
  overflow: hidden;
}
@media (min-width: 560px) {
  .slh-navigation .items-container {
    max-width: 512px;
  }
}
@media (min-width: 768px) {
  .slh-navigation .items-container {
    max-width: 696px;
  }
}
@media (min-width: 992px) {
  .slh-navigation .items-container {
    max-width: 936px;
  }
}
@media (min-width: 1200px) {
  .slh-navigation .items-container {
    max-width: 1116px;
  }
}
@media (min-width: 1400px) {
  .slh-navigation .items-container {
    max-width: 1296px;
  }
}
.slh-navigation .items-container.fluid {
  margin-right: auto;
  margin-left: auto;
  --left: 24px;
  --right: 24px;
  --sum: calc(var(--left) + var(--right));
  max-width: calc(100% - var(--sum));
}
@media (min-width: 992px) {
  .slh-navigation .items-container.fluid {
    --left: 32px;
    --right: 32px;
    --sum: calc(var(--left) + var(--right));
    max-width: calc(100% - var(--sum));
  }
}
@media (min-width: 1200px) {
  .slh-navigation .items-container.fluid {
    --left: 40px;
    --right: 40px;
    --sum: calc(var(--left) + var(--right));
    max-width: calc(100% - var(--sum));
  }
}
.slh-navigation .items-container.fluid.padding-sm {
  --left: 16px;
  --right: 16px;
  --sum: calc(var(--left) + var(--right));
  max-width: calc(100% - var(--sum));
}
@media (min-width: 992px) {
  .slh-navigation .items-container.fluid.padding-sm {
    --left: 24px;
    --right: 24px;
    --sum: calc(var(--left) + var(--right));
    max-width: calc(100% - var(--sum));
  }
}
@media (min-width: 1200px) {
  .slh-navigation .items-container.fluid.padding-sm {
    --left: 32px;
    --right: 32px;
    --sum: calc(var(--left) + var(--right));
    max-width: calc(100% - var(--sum));
  }
}

@media only screen and (max-width: calc(560px - 1px)) {
  .slh-navigation {
    height: auto;
    border: 0;
  }
  .slh-navigation .active-navigation-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .slh-navigation slot {
    flex-direction: column;
    display: none;
  }
  .slh-navigation .items-container {
    height: auto;
    overflow: auto;
  }
  .slh-navigation .items-container.fluid {
    max-width: 100%;
  }
  .slh-navigation .items-container.fluid.padding-sm {
    max-width: 100%;
  }
  .slh-navigation ::slotted(slh-navigation-item:first-child),
  .slh-navigation ::slotted(slh-navigation-item) {
    margin-left: 24px;
  }
  .slh-navigation.opened {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    z-index: 10000;
  }
  .slh-navigation.opened slot {
    display: flex;
  }
  .slh-navigation.opened .items-container {
    height: 100%;
  }
  .slh-navigation.opened slh-icon {
    transform: rotate(180deg);
  }
}
`;
